import { id } from '@swimlane/ngx-charts';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { throwError as observableThrowError, Observable } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class HttpService {
  tokens;

  deleteStatus = "Deleted";
  constructor(private http: HttpClient) { }
  token = localStorage.getItem("access_token");
  id = localStorage.getItem("restoID");

  // httpOptions1 = {
  //   headers: new HttpHeaders({

  //     Authorization:'Bearer ' + this.token
  //   })
  // };

  logout() {
    const data = {
      token: this.token,
    };
    return this.http.post(environment.serverUrl + "logout", data);
  }

  uploadDishAudio(data) {
    return this.http.post(environment.baseUrl + "uploadDishAudio", data);
  }

  isCoupanAvailiable(data) {
    let value = {
      status: data,
    };
    return this.http.put(environment.baseUrl + "isCoupanAvailiable", value);
  }

  getData(source: string) {
    return this.http.get(source).pipe(
      tap((res: any) => res),
      catchError(this.handleError)
    );
  }
  getReturant(id) {
    return this.http.get(environment.baseUrl + "restaurant?id=" + id);
  }
  //
  getallAllergens() {
    return this.http.get(environment.baseUrl + "allAllergens");
  }
  getallDiestpref() {
    return this.http.get(environment.baseUrl + "alldp");
  }

  getallActiveRestoAllergens() {
    return this.http.get(environment.baseUrl + "activeRestaurantAllergens");
  }
  getallActiveRestoDiestpref() {
    return this.http.get(environment.baseUrl + "activeRestaurantDietary");
  }
  getallActiveCategory(id) {
    return this.http.get(environment.baseUrl + 'restaurantDishType?restaurant_id=' + id);
  }
  getallUDP(id) {
    return this.http.get(environment.baseUrl + 'restaurantDpType?restaurant_id=' + id);
  }

  getallCategory() {
    return this.http.get(environment.baseUrl + "category");
  }
  getTag() {
    return this.http.get(environment.baseUrl + "tagList");
  }
  getReturantDetails(id) {
    return this.http.get(environment.baseUrl + "restaurantAllDishes?id=" + id);
  }
  getReturantMenuName(id) {
    return this.http.get(environment.baseUrl + "restaurantMenuNames?id=" + id);
  }
  getReturantAllMenuName(id) {
    return this.http.get(environment.baseUrl + "restaurantAllMenuNames?id=" + id);
  }
  updateReturantMenuNameStatus(data) {
    return this.http.put(environment.baseUrl + "updateMenuNameStatus", data);
  }

  addMenuName(data) {
    return this.http.post(environment.baseUrl + "addNewMenuName", data);
  }
  updateMenuLabelName(data) {
    return this.http.put(environment.baseUrl + "updateMenuName", data);
  }
  deleteMenuLabel(data) {
    return this.http.post(environment.baseUrl + "deleteMenuName", data);
  }
  deleteDish(id, restaurant_id) {
    const data = {
      dish_id: id,
      id: restaurant_id,
      status: "Deleted",
    };
    return this.http.put(environment.baseUrl + "dishStatusChange", data);
  }
  updateList(data) {
    return this.http.put(environment.baseUrl + "updateRestaurantDish", data);
  }
  Recomanded;
  AcitveRecomandedDish(value, restaurant_id, valueId) {
    if (value == "Active") {
      this.Recomanded = {
        dish_id: valueId,
        restaurant_id: restaurant_id,
        status: "Yes",
      };
    } else {
      this.Recomanded = {
        dish_id: valueId,
        restaurant_id: restaurant_id,
        status: "",
      };
    }

    return this.http.put(
      environment.baseUrl + "isRecommended",
      this.Recomanded
    );
  }

  crossContamination;
  AcitvecrossContamination(value, restaurant_id, valueId) {
    if (value == "Active") {
      this.crossContamination = {
        dish_id: valueId,
        restaurant_id: restaurant_id,
        status: "Yes",
      };
    } else {
      this.crossContamination = {
        dish_id: valueId,
        restaurant_id: restaurant_id,
        status: "",
      };
    }

    return this.http.put(
      environment.baseUrl + "crossContamination",
      this.crossContamination
    );
  }

  getAllAllergens() {
    return this.http.get(environment.baseUrl + "allRestaurantAllergens");
  }
  updateRestaurantStatusActiveInActive(data) {
    return this.http.put(environment.baseUrl + 'updateRestaurantOnlineStatus', data)
  }
  Custumactive;
  AcitveCustomizeDish(value, restaurant_id, valueId) {
    if (value == "Active") {
      this.Custumactive = {
        dish_id: valueId,
        restaurant_id: restaurant_id,
        status: "Yes",
      };
    } else {
      this.Custumactive = {
        dish_id: valueId,
        restaurant_id: restaurant_id,
        status: "",
      };
    }

    return this.http.put(
      environment.baseUrl + "isCustomized",
      this.Custumactive
    );
  }
  activs;
  AcitveInactiveDish(value, restaurant_id, valueId) {
    if (value == "Active") {
      this.activs = {
        dish_id: valueId,
        id: restaurant_id,
        status: "Inactive",
        resto_ids: restaurant_id
      };
    } else {
      this.activs = {
        dish_id: valueId,
        id: restaurant_id,
        status: "Active",
        resto_ids: restaurant_id
      };
    }
    return this.http.put(environment.baseUrl + "dishStatusChange", this.activs);
  }
  addList(id, data) {
    let formatData = new FormData();
    formatData.append("file", data);
    formatData.append("id", id);
    return this.http.post(environment.baseUrl + "dishUpload", formatData);
  }

  addImage(data) {
    return this.http.post(environment.baseUrl + "uploadDishImage", data);
  }
  getCsvTempData(id) {
    return this.http.get(
      environment.baseUrl + "dishFormat?restaurant_id=" + id
    );
  }

  private handleError(error: any) {
    return observableThrowError(error.error || "Server error");
  }
  getAllDietry() {
    return this.http.get(environment.baseUrl + "allRestaurantDietary");
  }

  status;
  updateDeliveryStatus(value) {
    if (value == "Active") {
      this.status = {
        status: "Active",
      };
    } else {
      this.status = {
        status: "Inactive",
      };
    }
    return this.http.put(
      environment.baseUrl + "restaurantDeliveryStatus",
      this.status
    );
  }
  updateSpiceTollranceStatus(data) {
    return this.http.put(environment.baseUrl + 'updateHideSpiceTolerance', data)
  }
  getTabledetail() {
    return this.http.get(environment.baseUrl + "restaurantTable");
  }

  UpdaterestoDetails(value) {
    return this.http.put(environment.baseUrl + "restaurant", value);
  }
  downLoadQr(id, restaurant_id) {
    return this.http.get(
      environment.baseUrl +
      "generateTableQr?table_id=" +
      id +
      "&restaurant_id=" +
      restaurant_id
    );
  }
  deletedata;
  deleteTable(value) {
    this.deletedata = {
      table_id: value,
      table_status: "Deleted",
    };
    return this.http.put(
      environment.baseUrl + "restaurantTable",
      this.deletedata
    );
  }

  upDatedata;
  upDateAllergence(value) {
    this.upDatedata = {
      allergen_id: value,
      allergen_status: "Active",
    };
    return this.http.put(
      environment.baseUrl + "restaurantAllergence",
      this.upDatedata
    );
  }

  upDateAllergenceinactive(value) {
    this.upDatedata = {
      allergen_id: value,
      allergen_status: "Inactive",
    };
    return this.http.put(
      environment.baseUrl + "restaurantAllergence",
      this.upDatedata
    );
  }

  getAllergenstatus() {
    return this.http.get(environment.baseUrl + "restaurantAllergence");
  }

  dataDietary;
  upDateDietary(value) {
    this.dataDietary = {
      dietary_id: value,
      dietary_status: "Active",
    };
    return this.http.put(
      environment.baseUrl + "restaurantDietary",
      this.dataDietary
    );
  }

  inactiveDietary(value) {
    this.dataDietary = {
      dietary_id: value,
      dietary_status: "Inactive",
    };
    return this.http.put(
      environment.baseUrl + "restaurantDietary",
      this.dataDietary
    );
  }

  result;
  addnewTable(value) {
    this.result = {
      table_name: value,
    };
    return this.http.post(environment.baseUrl + "restaurantTable", this.result);
  }

  deleteAllergens() {
    return this.http.delete(environment.baseUrl + "clearAllergence");
  }

  deletedietary() {
    return this.http.delete(environment.baseUrl + "clearDietary");
  }

  getDietarystatus() {
    return this.http.get(environment.baseUrl + "restaurantDietary");
  }

  ///update table order status///
  ordervalue;
  updateTableStatus(id, status) {
    this.ordervalue = {
      table_id: id,
      table_status: status,
    };
    return this.http.put(
      environment.baseUrl + "restaurantTable",
      this.ordervalue
    );
  }

  ////get table Name///
  getEditdata(id) {
    return this.http.get(
      environment.baseUrl + "singleTableName?table_id=" + id
    );
  }

  ////update table name////

  tablename;
  updateTableName(id, name) {
    this.tablename = {
      table_id: id,
      table_name: name,
    };

    return this.http.put(
      environment.baseUrl + "singleTableName",
      this.tablename
    );
  }

  //////For live orders////
  statusDineinlive;
  statusvalueslive = [
    "Pending",
    "Verified",
    "Accepted",
    "Cooking",
    "Ready",
    "ReadyToServe",
  ];
  restaurantDineInOrders() {
    this.statusDineinlive = {
      order_status: this.statusvalueslive,
    };
    return this.http.post(
      environment.baseUrl + "restaurantDineInOrders",
      this.statusDineinlive
    );
  }

  /////completed orders/////
  statusDineinCompleted;
  statusvaluescompleted = ["Completed", "Cancelled"];
  restaurantDineInOrderscompleted() {
    this.statusDineinCompleted = {
      order_status: this.statusvaluescompleted,
    };
    return this.http.post(
      environment.baseUrl + "restaurantDineInOrders",
      this.statusDineinCompleted
    );
  }

  ///Update Dinein Orderstatus////
  dineinliveStatus;
  UpdateDineinLiveOrderStatus(status, tableid) {
    this.dineinliveStatus = {
      table_id: tableid,
      order_status: status,
    };

    return this.http.put(
      environment.baseUrl + "dineInOrder",
      this.dineinliveStatus
    );
  }

  ////LIVEviewdetails////
  viewDetails;
  statusvaluesDetailslive = [
    "Pending",
    "Verified",
    "Accepted",
    "Cooking",
    "Ready",
  ];
  restaurantDineInOrdersViewDetails(id) {
    this.viewDetails = {
      order_status: ["Pending", "Verified", "Accepted", "Cooking", "Ready"],
      table_id: id,
    };

    return this.http.post(
      environment.baseUrl + "restaurantDineInOrdersById",
      this.viewDetails
    );
  }

  ////CompletedViewDetails////
  viewDetailsCompleted;
  restaurantDineInOrdersCompletedViewDetails(id) {
    this.viewDetailsCompleted = {
      order_status: ["Completed", "Cancelled"],
      table_id: id,
    };

    return this.http.post(
      environment.baseUrl + "restaurantDineInOrdersById",
      this.viewDetailsCompleted
    );
  }

  restaurantOrderStatusResto(Updatestatus) {
    let data = {
      status: Updatestatus,
    };
    return this.http.put(environment.baseUrl + "restaurantOrderStatus", data);
  }

  restaurantDesc() {
    return this.http.get(environment.baseUrl + "restaurantDesc");
  }
  updaterestaurantDesc(data) {
    return this.http.put(environment.baseUrl + "restaurantDesc", data);
  }

  upload_restaurant_image(data) {
    return this.http.post(
      environment.baseUrl + "upload_restaurant_image",
      data
    );
  }
  isNutriAvailiable(value) {
    let data = {
      status: value,
    };
    return this.http.put(environment.baseUrl + "isNutriAvailiable", data);
  }

  delete_dishImage(dish_id_value) {
    let data = {
      dish_id: dish_id_value,
    };
    return this.http.put(environment.baseUrl + "deleteDishImage", data);
  }

  delete_dishAudio(dish_id_value) {
    let data = {
      dish_id: dish_id_value,
    };
    return this.http.put(environment.baseUrl + "deleteDishAudio", data);
  }

  create_addOn(addon_name, addon_price, alrgoption, dietPref) {
    let data = {
      addon_name: addon_name,
      addon_price: addon_price,
      addon_allergens: alrgoption,
      addon_dietary: dietPref,
    };
    return this.http.post(environment.baseUrl + "addOn", data);
  }

  getAddon_details() {
    return this.http.get(environment.baseUrl + "addOn");
  }

  delete_addon(id) {
    let data = {
      status: "Deleted",
      addon_id: id,
    };
    return this.http.put(environment.baseUrl + "addonRemove", data);
  }
  addon_status(status, id) {
    let value = {
      status: status,
      addon_id: id,
    };
    return this.http.put(environment.baseUrl + "updateAddonStatus", value);
  }

  addondetailsById(id) {
    return this.http.get(environment.baseUrl + "addOnById?addon_id=" + id);
  }
  updateAddon(id, addonname, addonprice, addonallergens, addondietary) {
    let data = {
      addon_id: id,
      addon_name: addonname,
      addon_price: addonprice,
      addon_allergens: addonallergens,
      addon_dietary: addondietary,
    };
    return this.http.put(environment.baseUrl + "addOn", data);
  }

  dishAddon(id) {
    return this.http.get(environment.baseUrl + "dishAddOn?dish_id=" + id);
  }

  addOnList() {
    return this.http.get(environment.baseUrl + "addOnList");
  }

  CreateAddon(data) {
    return this.http.put(environment.baseUrl + "dishAddOn", data);
  }

  allOptionInDish_all(value) {
    return this.http.get(
      environment.baseUrl + "allOptionInDish?dish_id=" + value
    );
  }

  deleteDishOption(value) {
    let id = {
      option_id: value,
    };
    return this.http.put(environment.baseUrl + "deleteDishOption", id);
  }
  allOptionInDishs(data) {
    return this.http.post(environment.baseUrl + "allOptionInDish", data);
  }
  allAddOnInDish_get(dish_id) {
    return this.http.get(
      environment.baseUrl + "allAddOnInDish?dish_id=" + dish_id
    );
  }
  dishAddonRemove(dishid, addonid) {
    let ids = {
      dish_id: dishid,
      dish_addon_id: addonid,
    };
    return this.http.put(environment.baseUrl + "dishAddonRemove", ids);
  }

  allAddOnInDish(data) {
    return this.http.post(environment.baseUrl + "allAddOnInDish", data);
  }

  deleteCsvFile(data) {
    return this.http.get(
      environment.baseUrl + "deleteDishFormatFile?file_name=" + data
    );
  }
  addNewDish(data) {
    return this.http.post(environment.baseUrl + 'createRestaurantDish', data)
  }

  //super admin apis
  getRestoCount() {
    return this.http.get(
      environment.superAdminUrl + "restaurant_user_details_count"
    );
  }
  createRestaurant(data) {
    return this.http.post(environment.superAdminUrl + "createRestaurant", data);
  }
  updateRestaurant(data) {
    return this.http.post(environment.superAdminUrl + 'updateRestaurant', data)
  }
  deleteRestaurant(data) {
    return this.http.put(environment.superAdminUrl + "deleteRestaurant", data);
  }
  activateRestaurant(data) {
    return this.http.put(environment.superAdminUrl + 'updateRestaurantStatus', data)
  }
  getOneRestoDetails(data) {
    return this.http.get(
      environment.superAdminUrl + "getRestaurant" + "?restaurant_id=" + data
    );
  }
  getAlergensList() {
    return this.http.get(environment.superAdminUrl + "alergensList");
  }

  createAllergen(data) {
    return this.http.post(environment.superAdminUrl + "createAllergen", data);
  }
  updateAllergen(data) {
    return this.http.put(environment.superAdminUrl + "updateAllergen", data);
  }
  deleteAllergen(data) {
    return this.http.put(environment.superAdminUrl + "deleteAllergen", data);
  }
  getDietaryList() {
    return this.http.get(environment.superAdminUrl + "listDietaryPreference");
  }
  createDietaryPrefer(data) {
    return this.http.post(
      environment.superAdminUrl + "createDietaryPrefer",
      data
    );
  }
  updateDietaryPrefer(data) {
    return this.http.put(
      environment.superAdminUrl + "updateDietaryPrefer",
      data
    );
  }
  deleteDietaryPrefer(data) {
    return this.http.put(
      environment.superAdminUrl + "deleteDietaryPreference",
      data
    );
  }
  allCategory() {
    return this.http.get(environment.categoryAndCuisineUrl + "allCategory");
  }
  createCategory(data) {
    return this.http.post(environment.superAdminUrl + "createCategory", data);
  }
  upadateCategory(data) {
    return this.http.post(environment.superAdminUrl + 'updateCategory', data)
  }
  deleteCategory(data) {
    return this.http.put(environment.superAdminUrl + "deleteCategory", data);
  }
  allCuisine() {
    return this.http.get(environment.categoryAndCuisineUrl + "allCuisine");
  }
  createCuisine(data) {
    return this.http.post(environment.superAdminUrl + "createCuisine", data);
  }
  updateCuisine(data) {
    return this.http.post(environment.superAdminUrl + 'updateCuisine', data)
  }
  deleteCuisine(data) {
    return this.http.put(environment.superAdminUrl + "deleteCuisine", data);
  }
  getAllrestaurantsList() {
    return this.http.get(environment.superAdminUrl + "restaurantList");
  }
  getRestoAccount() {
    return this.http.get(environment.superAdminUrl + 'getRestaurantInfo')
  }
  changeRestaurantPassword(data) {
    return this.http.post(environment.superAdminPasswordUrl + 'changeRestaurantPassword', data)
  }
  getAdminInformation() {
    return this.http.get(environment.superAdminUrl + 'getAdminInfo')
  }
  updateAdminInfo(data) {
    return this.http.post(environment.superAdminUrl + 'updateAdminProfile', data)
  }
  getAllLevelRestoList() {
    return this.http.get(environment.superAdminUrl + 'getAllRestoIdName')
  }
  getAllWeeklyRestoList() {
    return this.http.get(environment.superAdminUrl + 'getSpecialCategoryRestoIdName')
  }
  updateWeeklyList(data) {
    return this.http.post(environment.superAdminUrl + 'updateWeekelyTop10Restaurant', data)
  }
  updateAdminPassword(data) {
    return this.http.post(environment.loginUrl + 'changeSuperAdminPassword', data)
  }
  // ------------ DataBase 2 Apis---------------------
  getAllD2Resto() {
    return this.http.get(environment.d2RestoUrl + 'getRestaurants')
  }
  getAllCsvResto() {
    return this.http.get(environment.d2RestoUrl + 'getCsvRestaurantList')
  }
  updateCsvRestoStatus(data) {
    return this.http.put(environment.d2RestoUrl + 'updateCsvRestaurantStatus', data)
  }
  getAllD2Dieatry() {
    return this.http.get(environment.d2RestoUrl + 'dietPreference')
  }
  getAllD2DAllergen() {
    return this.http.get(environment.d2RestoUrl + 'alergensList')
  }
  getAllD2Cuisine() {
    return this.http.get(environment.d2RestoUrl + 'cuisineList')
  }
  getAllD2Category() {
    return this.http.get(environment.d2RestoUrl + 'categoryList')
  }
  getOneD2RestoDetails(data) {
    return this.http.get(environment.d2RestoUrl + 'getRestaurantsById?restaurant_id=' + data)
  }
  updateD2Restaurant(data) {
    return this.http.post(environment.d2RestoUrl + 'updateRestaurant', data)
  }



  getAllergensChart(resto_id: any, categoryId: any = null) {
    let url = environment.baseUrl + 'restaurantAllergensChart?restaurant_id=' + resto_id
    if (categoryId) url = url + `&dish_type_id=${categoryId}`
    return this.http.get(url)
  }
  
  getUnsuitableChart(resto_id: any, categoryId: any = null) {
    let url = environment.baseUrl + 'dishUnsuitableDietaryPreferenceCharts?restaurant_id=' + resto_id
    if (categoryId) url = url + `&dish_type_id=${categoryId}`
    return this.http.get(url)
  }
  updateReviewByDtls(data: any) {
    return this.http.put(environment.baseUrl + 'updateRestaurantReviewed', data)
  }
  // ---------------------------------------------------------------------------------------------------
  getAllClaimResto() {
    return this.http.get(environment.superAdminUrl + 'getRestaurantNameId')
  }
  getEmailOfResto(data) {
    return this.http.get(environment.superAdminUrl + 'getRestaurantEmailById?restaurant_id=' + data)
  }
  sendOtpByEmail(email) {
    let data = {
      email: email
    }
    return this.http.post(environment.serverUrl + 'sendOtpByEmail', data)
  }

  getAutoCompleteResto(data) {
    // const headers = new HttpHeaders().set('X-Skip-Loader', 'true');
    return this.http.get(environment.d2RestoUrl + 'getRestaurants?query=' + data)
  }

  getGoogleRestoDtls(place_id: any) {
    return this.http.get(environment.d2RestoUrl + 'getRestaurantsDtls?place_id=' + place_id)
  }
  checkRestoExists(place_id: string) {
    return this.http.get(environment.claimResto + 'check_claim_status?place_id=' + place_id)
  }
  getRestoDetailsByAI(data: any) {
    return this.http.post(environment.d2RestoUrl + 'getRestaurantDtlsAi', data)
  }

  getAIImages(data: any) {
    return this.http.post(environment.d2RestoUrl + 'getRestoImage', data)
  }

  getRestoImagesByAI(data: any) {
    return this.http.post(environment.d2RestoUrl + 'getRestoImage', data)
  }

  verifyOTPUser(data: any) {
    return this.http.post(environment.serverUrl + 'verifyOtp', data)
  }
  updateD2PartialResto(data) {
    return this.http.post(environment.claimResto + 'partialClaimRestaurant', data)
  }
  getPartialRestoDtls(id: any) {
    return this.http.get(environment.claimResto + 'getPartialClaimRestaurantDtls' + '?restaurant_id=' + id)
  }
  getAllPartialRestoDtls() {
    return this.http.get(environment.claimResto + 'getAllPartialClaimRestaurant')
  }
  deletePartialRestoById(id: any) {
    let payload = {
      'resto_id': id
    }
    return this.http.put(environment.claimResto + 'deletePartialClaimRestaurant', payload)
  }

  sendEmailToPartialResto(data: any) {
    return this.http.post(environment.claimResto + 'sendPartialEmail', data)
  }

  claimSubmit(data) {
    return this.http.post(environment.claimResto + 'claimRestaurant', data)
  }

  createPartialData(data) {
    return this.http.post(environment.claimResto + 'createPartialInfo', data)
  }
  getClaimedAllResto() {
    return this.http.get(environment.claimResto + 'getClaimRestaurants')
  }
  getOneClaimRestoDetails(data) {
    return this.http.get(environment.claimResto + 'getClaimRestaurantsById?restaurant_id=' + data)
  }
  approveRestaurant(data) {
    return this.http.post(environment.claimResto + 'approveRestaurant', data)
  }



  // Nutrilable apis

  getAllNutriIngriedints() {
    return this.http.get(environment.nutriLabel + 'getingredientsList')
  }
  getNutriDishTypes() {
    return this.http.get(environment.nutriLabel + 'getDishTypes')
  }
  getAllNutriCategoryAndAllergens() {
    return this.http.get(environment.nutriLabel + 'getAllergenDps')
  }
  getAllMacroMicro() {
    return this.http.get(environment.nutriLabel + 'getNutritions')
  }
  addNutriRecipe(data) {
    return this.http.post(environment.nutriLabel + 'postRecipe', data)
  }





  addMasterRestaurant(data) {
    return this.http.post(environment.superAdminUrl + 'addMasterRestaurant', data)
  }

  updateMasterRestaurant(data) {
    return this.http.put(environment.superAdminUrl + 'updateMasterRestaurant', data)
  }

  getMasterRestaurant() {
    return this.http.get(environment.superAdminUrl + 'masterRestaurant')
  }
  getTokenRestaurant(data) {
    return this.http.post(environment.baseUrl + 'tokenByRestaurant', data)
  }

  readMenuImages(data: any) {
    return this.http.post(environment.d2RestoUrl + 'parse_menu_from_images', data)
  }


  sendRemiderEmail(data: any) {
    return this.http.post(environment.baseUrl + 'sendQrMenuReminder', data)
  }

  sendCredentialsEmail(data: any) {
    return this.http.post(environment.superAdminUrl + 'sendCredentialsToRestaurantOwner', data)
  }


  deleteMultiDish(data: any) {
    return this.http.put(environment.baseUrl + 'removeDishes', data)
  }

  deleteClaimResto(id: any) {
    return this.http.delete(environment.claimResto + 'deleteClaimRestaurants/' + id + '/')
  }

  



  // Email Template

  private baseUrl = 'http://localhost/foodbud/index.php/api/email-templates';

  saveTemplate(payload: any): Observable<any> {
    return this.http.post(environment.superAdminUrl + 'insertOrUpdateEmailTemplate', payload);
  }

  getTemplate(): Observable<any> {
    return this.http.get(environment.superAdminUrl + 'getEmailTemplates')
  }

  sendTemplate(id: number, payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/send/${id}`, payload);
  }

  //Menu PDF
  getAllMenu(id:any, table_id:any){
    return this.http.get(environment.superAdminUrl + 'getRestaurantMenus?restaurant_id=' + id + '&table_id=' + 1)
  }




  //Regulatory Info & Event Plan
  getRegulatoryInfo(){
    return this.http.get(environment.superAdminUrl + 'getRegulatoryInfos')
  }

  createUpdateRegulatoryInfo(data:any){
    return this.http.post(environment.superAdminUrl + 'addRegulatoryInfos', data)
  }

  deleteRegulatoryInfo(id:any){
    return this.http.delete(environment.superAdminUrl + 'deleteRegulatory?id=' + id)
  }


  getEventPlan(){
    return this.http.get(environment.superAdminUrl + 'getPlanningCalendar')
  }

  createUpdateEventPlan(data:any){
    return this.http.post(environment.superAdminUrl + 'addPlanningCalendar', data)
  }
  deleteEventPlan(id:any){
    return this.http.delete(environment.superAdminUrl + 'deletePlanningCalendar?id=' + id)
  }

  getMenuPlanning(){
    return this.http.get(environment.superAdminUrl + 'getPlanningResources')
  }

  createUpdateMenuPlanning(data:any){
    return this.http.post(environment.superAdminUrl + 'addPlanningResources', data)
  }
  deleteMenuPlanning(id:any){
    return this.http.delete(environment.superAdminUrl + 'deletePlanningResources?id=' + id)
  }


  //Analytics
  getRestaurantAnalytics(id:any, range:any=null){
    if(range != null){
      return this.http.get(environment.baseUrl + 'getDashboardInsights?restaurant_id=' + id + '&range=' + range)
    }
    return this.http.get(environment.baseUrl + 'getDashboardInsights?restaurant_id=' + id)
  }

  getAdminAnalytics(range:any=null){
    if(range != null){
      return this.http.get(environment.baseUrl + 'getDashboardInsights' + '?range=' + range)
    }
    return this.http.get(environment.superAdminUrl + 'getDashboardInsights')
  }
}
